<template>
  <b-skeleton-wrapper :loading="loading">
    <template #loading>
      <b-row class="parvandeh-reports-list m-0">
        <b-col
          v-for="(item, index) in items"
          :key="index"
          cols="12"
          class="parvandeh-reports-list__item"
        >
          <div class="parvandeh-reports-list__line">
            <b-skeleton width="100%"></b-skeleton>
          </div>
          <div class="parvandeh-reports-list__line">
            <b-skeleton width="100%"></b-skeleton>
          </div>
          <div class="parvandeh-reports-list__line">
            <b-skeleton width="70%"></b-skeleton>
          </div>
          <div class="parvandeh-reports-list__line">
            <b-skeleton width="50%"></b-skeleton>
          </div>
        </b-col>
      </b-row>
    </template>
    <slot name="default"></slot>
  </b-skeleton-wrapper>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    count: {
      type: Number,
      default: 6,
    },
  },
  computed: {
    items() {
      const arr = [];
      arr.length = this.count;
      return arr;
    },
  },
};
</script>
